<script>
import { mapActions, mapState } from "vuex";

import OrderDetails from "./Details";
import RequiredBy from "./RequiredBy";
import ToBe from "@/components/PurchaseFlow/Steps/ToBe";
import PerSchedule from "@/components/PurchaseFlow/PerSchedule";
import PerProfessional from "@/components/PurchaseFlow/PerProfessional";
import Confirmation from "@/components/PurchaseFlow/Steps/Confirmation";

import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [orderMixin],

  components: {
    OrderDetails,
    RequiredBy,
    ToBe,
    PerSchedule,
    PerProfessional,
    Confirmation
  },

  computed: {
    ...mapState("newOrder", [
      "to_be",
      "orderToRebook",
      "professional",
      "price_confirmed",
      "requester"
    ])
  },

  methods: {
    ...mapActions("orders", ["getById"]),
    ...mapActions("newOrder", ["setOrderToRebook", "resetState"]),
    async setOrder() {
      try {
        let order = await this.getById(this.$route.params.id);

        if (!this.canReschedule(order.status))
          throw "O pedido não pode ser reagendado!";
        this.setOrderToRebook(order);
      } catch (e) {
        this.$toast.error(e, {
          icon: "error"
        });
        this.$router.push({
          name: "order",
          params: { id: this.$route.params.id }
        });
      }
    },
    rebooked() {
      this.$toast.success("O pedido foi reagendado!", {
        icon: "check_circle"
      });
      this.$router.push({
        name: "order",
        params: { id: this.$route.params.id }
      });
    }
  },

  mounted() {
    this.setOrder();
  },

  beforeDestroy() {
    this.resetState();
  }
};
</script>

<template>
  <v-card v-if="orderToRebook" class="py-4" flat>
    <order-details :order="orderToRebook" />
    <required-by />
    <to-be title="você deseja reagendar" v-if="requester" />

    <transition name="fade" mode="out-in">
      <per-schedule v-if="to_be === 'schedule'" />
      <per-professional v-else-if="to_be === 'professional'" />
    </transition>

    <transition name="fade" mode="out-in">
      <confirmation
        v-if="professional && price_confirmed"
        id="confirmation"
        @rebooked="rebooked"
      />
    </transition>
  </v-card>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Orders/Rebooking/Index.vue